import React from 'react';
import './BadgeIcon.css';

function BadgeIcon({ badge, className = '' }) {
  if (!badge) return null;
  const classes = ['chat-badge', className].filter(Boolean).join(' ');

  if (badge.svg) {
    return (
      <span
        className={classes}
        aria-hidden="true"
        dangerouslySetInnerHTML={{ __html: badge.svg }}
      />
    );
  }

  if (badge.url) {
    return (
      <img
        className={classes}
        src={badge.url}
        alt=""
        width={32}
        height={32}
        loading="lazy"
        decoding="async"
      />
    );
  }

  return null;
}

export default BadgeIcon;